// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: lenses/remote_api/remote_api_spec.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "snapchat.lenses";

/** Data interface used by an API endpoint */
export enum RemoteApiEndpointType {
  /** TYPE_UNSET - Invalid empty value */
  TYPE_UNSET = "TYPE_UNSET",
  /** TEXT - Text-based API, usually JSON */
  TEXT = "TEXT",
  /** PROTO - Protobuf-based API, request and response are proto messages */
  PROTO = "PROTO",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiEndpointTypeFromJSON(object: any): RemoteApiEndpointType {
  switch (object) {
    case 0:
    case "TYPE_UNSET":
      return RemoteApiEndpointType.TYPE_UNSET;
    case 1:
    case "TEXT":
      return RemoteApiEndpointType.TEXT;
    case 2:
    case "PROTO":
      return RemoteApiEndpointType.PROTO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiEndpointType.UNRECOGNIZED;
  }
}

export function remoteApiEndpointTypeToNumber(object: RemoteApiEndpointType): number {
  switch (object) {
    case RemoteApiEndpointType.TYPE_UNSET:
      return 0;
    case RemoteApiEndpointType.TEXT:
      return 1;
    case RemoteApiEndpointType.PROTO:
      return 2;
    case RemoteApiEndpointType.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Defines caching behavior for an endpoint */
export enum RemoteApiCacheStrategy {
  /** CS_UNSET - Invalid empty value */
  CS_UNSET = "CS_UNSET",
  /** USE_HEADERS - Rely on Cache-control headers */
  USE_HEADERS = "USE_HEADERS",
  /** ALWAYS - Always cache */
  ALWAYS = "ALWAYS",
  /** NEVER - Never cache */
  NEVER = "NEVER",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiCacheStrategyFromJSON(object: any): RemoteApiCacheStrategy {
  switch (object) {
    case 0:
    case "CS_UNSET":
      return RemoteApiCacheStrategy.CS_UNSET;
    case 1:
    case "USE_HEADERS":
      return RemoteApiCacheStrategy.USE_HEADERS;
    case 2:
    case "ALWAYS":
      return RemoteApiCacheStrategy.ALWAYS;
    case 3:
    case "NEVER":
      return RemoteApiCacheStrategy.NEVER;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiCacheStrategy.UNRECOGNIZED;
  }
}

export function remoteApiCacheStrategyToNumber(object: RemoteApiCacheStrategy): number {
  switch (object) {
    case RemoteApiCacheStrategy.CS_UNSET:
      return 0;
    case RemoteApiCacheStrategy.USE_HEADERS:
      return 1;
    case RemoteApiCacheStrategy.ALWAYS:
      return 2;
    case RemoteApiCacheStrategy.NEVER:
      return 3;
    case RemoteApiCacheStrategy.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Normally, proxy relies on the response Cache-control header to determine cache TTL.
 * When to override 3p API-provided cache TTL with the one specified in the spec
 */
export enum RemoteApiCacheTTLStrategy {
  /** CTS_UNSET - Never override TTL from Cache-control header */
  CTS_UNSET = "CTS_UNSET",
  /** EXACT - Always use spec-provided TTL, ignore Cache-control header */
  EXACT = "EXACT",
  /** FLOOR - Use spec-provided TTL if Cache-control TTL is less */
  FLOOR = "FLOOR",
  /** CEILING - Use spec-provided TTL if Cache-control TTL is greater */
  CEILING = "CEILING",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiCacheTTLStrategyFromJSON(object: any): RemoteApiCacheTTLStrategy {
  switch (object) {
    case 0:
    case "CTS_UNSET":
      return RemoteApiCacheTTLStrategy.CTS_UNSET;
    case 1:
    case "EXACT":
      return RemoteApiCacheTTLStrategy.EXACT;
    case 2:
    case "FLOOR":
      return RemoteApiCacheTTLStrategy.FLOOR;
    case 3:
    case "CEILING":
      return RemoteApiCacheTTLStrategy.CEILING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiCacheTTLStrategy.UNRECOGNIZED;
  }
}

export function remoteApiCacheTTLStrategyToNumber(object: RemoteApiCacheTTLStrategy): number {
  switch (object) {
    case RemoteApiCacheTTLStrategy.CTS_UNSET:
      return 0;
    case RemoteApiCacheTTLStrategy.EXACT:
      return 1;
    case RemoteApiCacheTTLStrategy.FLOOR:
      return 2;
    case RemoteApiCacheTTLStrategy.CEILING:
      return 3;
    case RemoteApiCacheTTLStrategy.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Options in HTTP request to run through ALD (Abuse Language Detection) */
export enum AldRequestValidationConfig {
  /** ALD_REQ_CONFIG_UNSET - Unset */
  ALD_REQ_CONFIG_UNSET = "ALD_REQ_CONFIG_UNSET",
  /** REQ_BODY - Request Body */
  REQ_BODY = "REQ_BODY",
  /** REQ_URL - Request URL */
  REQ_URL = "REQ_URL",
  /** REQ_HEADERS - Request headers */
  REQ_HEADERS = "REQ_HEADERS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function aldRequestValidationConfigFromJSON(object: any): AldRequestValidationConfig {
  switch (object) {
    case 0:
    case "ALD_REQ_CONFIG_UNSET":
      return AldRequestValidationConfig.ALD_REQ_CONFIG_UNSET;
    case 1:
    case "REQ_BODY":
      return AldRequestValidationConfig.REQ_BODY;
    case 2:
    case "REQ_URL":
      return AldRequestValidationConfig.REQ_URL;
    case 3:
    case "REQ_HEADERS":
      return AldRequestValidationConfig.REQ_HEADERS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AldRequestValidationConfig.UNRECOGNIZED;
  }
}

export function aldRequestValidationConfigToNumber(object: AldRequestValidationConfig): number {
  switch (object) {
    case AldRequestValidationConfig.ALD_REQ_CONFIG_UNSET:
      return 0;
    case AldRequestValidationConfig.REQ_BODY:
      return 1;
    case AldRequestValidationConfig.REQ_URL:
      return 2;
    case AldRequestValidationConfig.REQ_HEADERS:
      return 3;
    case AldRequestValidationConfig.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Options in HTTP response to run through ALD (Abuse Language Detection) */
export enum AldResponseValidationConfig {
  /** ALD_RESP_CONFIG_UNSET - Unset */
  ALD_RESP_CONFIG_UNSET = "ALD_RESP_CONFIG_UNSET",
  /** RESP_BODY - Response Body */
  RESP_BODY = "RESP_BODY",
  /** RESP_HEADERS - Response headers */
  RESP_HEADERS = "RESP_HEADERS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function aldResponseValidationConfigFromJSON(object: any): AldResponseValidationConfig {
  switch (object) {
    case 0:
    case "ALD_RESP_CONFIG_UNSET":
      return AldResponseValidationConfig.ALD_RESP_CONFIG_UNSET;
    case 1:
    case "RESP_BODY":
      return AldResponseValidationConfig.RESP_BODY;
    case 2:
    case "RESP_HEADERS":
      return AldResponseValidationConfig.RESP_HEADERS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AldResponseValidationConfig.UNRECOGNIZED;
  }
}

export function aldResponseValidationConfigToNumber(object: AldResponseValidationConfig): number {
  switch (object) {
    case AldResponseValidationConfig.ALD_RESP_CONFIG_UNSET:
      return 0;
    case AldResponseValidationConfig.RESP_BODY:
      return 1;
    case AldResponseValidationConfig.RESP_HEADERS:
      return 2;
    case AldResponseValidationConfig.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Approval state of an API spec
 * See more: https://docs.google.com/document/d/1uNuHwRT6a5_XBNQ1gZGNpdNVUEaTTCYkMFtnj7r3Z24/edit?usp=sharing
 */
export enum SpecApprovalState {
  /** APPROVAL_STATE_UNSET - Invalid value */
  APPROVAL_STATE_UNSET = "APPROVAL_STATE_UNSET",
  /** IN_REVIEW - In review */
  IN_REVIEW = "IN_REVIEW",
  /** APPROVED - Approved */
  APPROVED = "APPROVED",
  /** BLOCKED - Blocked */
  BLOCKED = "BLOCKED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function specApprovalStateFromJSON(object: any): SpecApprovalState {
  switch (object) {
    case 0:
    case "APPROVAL_STATE_UNSET":
      return SpecApprovalState.APPROVAL_STATE_UNSET;
    case 1:
    case "IN_REVIEW":
      return SpecApprovalState.IN_REVIEW;
    case 2:
    case "APPROVED":
      return SpecApprovalState.APPROVED;
    case 3:
    case "BLOCKED":
      return SpecApprovalState.BLOCKED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpecApprovalState.UNRECOGNIZED;
  }
}

export function specApprovalStateToNumber(object: SpecApprovalState): number {
  switch (object) {
    case SpecApprovalState.APPROVAL_STATE_UNSET:
      return 0;
    case SpecApprovalState.IN_REVIEW:
      return 1;
    case SpecApprovalState.APPROVED:
      return 2;
    case SpecApprovalState.BLOCKED:
      return 3;
    case SpecApprovalState.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Who should be able to see/use the spec */
export enum SpecVisibility {
  /** VISIBILITY_UNSET - Invalid value */
  VISIBILITY_UNSET = "VISIBILITY_UNSET",
  /**
   * INTERNAL - Only internal Lens Studio versions
   *
   * @deprecated
   */
  INTERNAL = "INTERNAL",
  /** PRIVATE - Only the spec creator and those on allowlist */
  PRIVATE = "PRIVATE",
  /** EXTERNAL - Accessible to everyone */
  EXTERNAL = "EXTERNAL",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function specVisibilityFromJSON(object: any): SpecVisibility {
  switch (object) {
    case 0:
    case "VISIBILITY_UNSET":
      return SpecVisibility.VISIBILITY_UNSET;
    case 1:
    case "INTERNAL":
      return SpecVisibility.INTERNAL;
    case 2:
    case "PRIVATE":
      return SpecVisibility.PRIVATE;
    case 3:
    case "EXTERNAL":
      return SpecVisibility.EXTERNAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SpecVisibility.UNRECOGNIZED;
  }
}

export function specVisibilityToNumber(object: SpecVisibility): number {
  switch (object) {
    case SpecVisibility.VISIBILITY_UNSET:
      return 0;
    case SpecVisibility.INTERNAL:
      return 1;
    case SpecVisibility.PRIVATE:
      return 2;
    case SpecVisibility.EXTERNAL:
      return 3;
    case SpecVisibility.UNRECOGNIZED:
    default:
      return -1;
  }
}

/**
 * Where was this api created from; in the future we may end up with
 * different behavior for Specs created from different properties
 */
export enum CreatedFrom {
  /** CREATED_FROM_UNSET - Invalid value */
  CREATED_FROM_UNSET = "CREATED_FROM_UNSET",
  /** REMOTE_API_ADMIN - This was created on Remote-Api-Admin by an internal team member */
  REMOTE_API_ADMIN = "REMOTE_API_ADMIN",
  /** MY_LENSES - This was created on My-Lenses by an external team member */
  MY_LENSES = "MY_LENSES",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function createdFromFromJSON(object: any): CreatedFrom {
  switch (object) {
    case 0:
    case "CREATED_FROM_UNSET":
      return CreatedFrom.CREATED_FROM_UNSET;
    case 1:
    case "REMOTE_API_ADMIN":
      return CreatedFrom.REMOTE_API_ADMIN;
    case 2:
    case "MY_LENSES":
      return CreatedFrom.MY_LENSES;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CreatedFrom.UNRECOGNIZED;
  }
}

export function createdFromToNumber(object: CreatedFrom): number {
  switch (object) {
    case CreatedFrom.CREATED_FROM_UNSET:
      return 0;
    case CreatedFrom.REMOTE_API_ADMIN:
      return 1;
    case CreatedFrom.MY_LENSES:
      return 2;
    case CreatedFrom.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** What platform this spec is targeting */
export enum TargetPlatform {
  /** TARGET_PLATFORM_UNSET - Invalid value */
  TARGET_PLATFORM_UNSET = "TARGET_PLATFORM_UNSET",
  /** SNAPCHAT - Accessible to lenses on Snapchat */
  SNAPCHAT = "SNAPCHAT",
  /** SPECTACLES - Accessible to lenses on Spectacles */
  SPECTACLES = "SPECTACLES",
  /** CAMERA_KIT - Accessible to CameraKit */
  CAMERA_KIT = "CAMERA_KIT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function targetPlatformFromJSON(object: any): TargetPlatform {
  switch (object) {
    case 0:
    case "TARGET_PLATFORM_UNSET":
      return TargetPlatform.TARGET_PLATFORM_UNSET;
    case 1:
    case "SNAPCHAT":
      return TargetPlatform.SNAPCHAT;
    case 2:
    case "SPECTACLES":
      return TargetPlatform.SPECTACLES;
    case 3:
    case "CAMERA_KIT":
      return TargetPlatform.CAMERA_KIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TargetPlatform.UNRECOGNIZED;
  }
}

export function targetPlatformToNumber(object: TargetPlatform): number {
  switch (object) {
    case TargetPlatform.TARGET_PLATFORM_UNSET:
      return 0;
    case TargetPlatform.SNAPCHAT:
      return 1;
    case TargetPlatform.SPECTACLES:
      return 2;
    case TargetPlatform.CAMERA_KIT:
      return 3;
    case TargetPlatform.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Defines which api access level the lens has: https://snapchat.quip.com/RS86Adtd8lZI */
export enum RestrictedJsApiPermission {
  /** PERMISSION_UNSET - Invalid value */
  PERMISSION_UNSET = "PERMISSION_UNSET",
  /** USER_DATA - Lenses that use this API can access user data */
  USER_DATA = "USER_DATA",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function restrictedJsApiPermissionFromJSON(object: any): RestrictedJsApiPermission {
  switch (object) {
    case 0:
    case "PERMISSION_UNSET":
      return RestrictedJsApiPermission.PERMISSION_UNSET;
    case 1:
    case "USER_DATA":
      return RestrictedJsApiPermission.USER_DATA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RestrictedJsApiPermission.UNRECOGNIZED;
  }
}

export function restrictedJsApiPermissionToNumber(object: RestrictedJsApiPermission): number {
  switch (object) {
    case RestrictedJsApiPermission.PERMISSION_UNSET:
      return 0;
    case RestrictedJsApiPermission.USER_DATA:
      return 1;
    case RestrictedJsApiPermission.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** (only for internal API endpoints) Possible use cases for user location */
export enum UserLocationUseCase {
  /** USE_CASE_UNSET - Undefined use case */
  USE_CASE_UNSET = "USE_CASE_UNSET",
  /** WEATHER - Weather info in user area (zoom level 10) */
  WEATHER = "WEATHER",
  /** PLACES - Finding nearby places (zoom level 18) */
  PLACES = "PLACES",
  /** PLACES_COARSE - Finding nearby places at a more coarse level (zoom level 17) */
  PLACES_COARSE = "PLACES_COARSE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function userLocationUseCaseFromJSON(object: any): UserLocationUseCase {
  switch (object) {
    case 0:
    case "USE_CASE_UNSET":
      return UserLocationUseCase.USE_CASE_UNSET;
    case 1:
    case "WEATHER":
      return UserLocationUseCase.WEATHER;
    case 2:
    case "PLACES":
      return UserLocationUseCase.PLACES;
    case 3:
    case "PLACES_COARSE":
      return UserLocationUseCase.PLACES_COARSE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return UserLocationUseCase.UNRECOGNIZED;
  }
}

export function userLocationUseCaseToNumber(object: UserLocationUseCase): number {
  switch (object) {
    case UserLocationUseCase.USE_CASE_UNSET:
      return 0;
    case UserLocationUseCase.WEATHER:
      return 1;
    case UserLocationUseCase.PLACES:
      return 2;
    case UserLocationUseCase.PLACES_COARSE:
      return 3;
    case UserLocationUseCase.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Defines how a parameter is injected into an HTTP request */
export interface RemoteApiHttpRequestParameter {
  /** Unique name of the parameter */
  name: string;
  /** Location of the parameter */
  location: RemoteApiHttpRequestParameter_ParameterLocation;
  /** Is parameter optional */
  optional: boolean;
  /**
   * (optional) Name of the parameter that will be used to construct the request (in query/headers/path).
   * `name` is used by clients to fill in the parameters in the request, whereas
   * `external_name` is what is used in the outgoing API request by the proxy.
   * If empty, `external_name` is assumed to be the same as `name`.
   */
  externalName: string;
  /**
   * Default value if the parameter is not set. Useful for "standard" headers like content-type
   * and other similar cases. If a default value is provided, the parameter will be sent with every request.
   * Required for constant parameters.
   */
  defaultValue: string;
  /**
   * Constant parameters have the same predefined value for all requests and
   * are always set by the proxy. Not allowed to be overridden by the caller.
   */
  constant: boolean;
}

/** Possible location of a parameter */
export enum RemoteApiHttpRequestParameter_ParameterLocation {
  /** LOCATION_UNSET - Undefined location */
  LOCATION_UNSET = "LOCATION_UNSET",
  /** QUERY - Parameters that appear in the URL query */
  QUERY = "QUERY",
  /** HEADER - Parameters that appear in the HTTP request header */
  HEADER = "HEADER",
  /** PATH - Parameters that appear in the URL path (for parameterized path only) */
  PATH = "PATH",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiHttpRequestParameter_ParameterLocationFromJSON(
  object: any,
): RemoteApiHttpRequestParameter_ParameterLocation {
  switch (object) {
    case 0:
    case "LOCATION_UNSET":
      return RemoteApiHttpRequestParameter_ParameterLocation.LOCATION_UNSET;
    case 1:
    case "QUERY":
      return RemoteApiHttpRequestParameter_ParameterLocation.QUERY;
    case 2:
    case "HEADER":
      return RemoteApiHttpRequestParameter_ParameterLocation.HEADER;
    case 3:
    case "PATH":
      return RemoteApiHttpRequestParameter_ParameterLocation.PATH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiHttpRequestParameter_ParameterLocation.UNRECOGNIZED;
  }
}

export function remoteApiHttpRequestParameter_ParameterLocationToNumber(
  object: RemoteApiHttpRequestParameter_ParameterLocation,
): number {
  switch (object) {
    case RemoteApiHttpRequestParameter_ParameterLocation.LOCATION_UNSET:
      return 0;
    case RemoteApiHttpRequestParameter_ParameterLocation.QUERY:
      return 1;
    case RemoteApiHttpRequestParameter_ParameterLocation.HEADER:
      return 2;
    case RemoteApiHttpRequestParameter_ParameterLocation.PATH:
      return 3;
    case RemoteApiHttpRequestParameter_ParameterLocation.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** (only for PROTO endpoints) Represents names of fields in a proto response, as well as an optional macro value */
export interface RemoteApiHttpResponseParameter {
  /** Unique name of the parameter */
  name: string;
  /** Whether or not we want to expose this parameter in the final API response to user */
  hidden: boolean;
  /** Specific macro values indicate certain parameters and types that we want to map this proto field to. */
  macroValue: string;
}

/** Metadata for remote API endpoints */
export interface RemoteApiEndpointMetadata {
  /** Human-readable name for the endpoint */
  name: string;
  /** Description that may include links to documentation, etc. */
  description: string;
}

/** Determines how the proxy should cache third party responses */
export interface RemoteApiCachingConfig {
  /** When to cache */
  cacheStrategy: RemoteApiCacheStrategy;
  /** Which TTL to use when caching */
  ttlStrategy: RemoteApiCacheTTLStrategy;
  /** Custom TTL override value */
  ttlSec: string;
}

/** Defines a remote API HTTP endpoint */
export interface RemoteApiHttpEndpoint {
  /** URL path of the endpoint; could be fixed or parameterized */
  path: string;
  /** HTTP methods allowed for requests to this endpoint */
  methods: RemoteApiHttpEndpoint_HttpRequestMethod[];
  /** Parameters allowed for requests to this endpoint; required if path is parameterized */
  parameters: RemoteApiHttpRequestParameter[];
  /** Metadata */
  metadata:
    | RemoteApiEndpointMetadata
    | undefined;
  /** ID used by clients to refer to this endpoint */
  refId: string;
  /** Type of the endpoint */
  type: RemoteApiEndpointType;
  /** Serialized protobuf descriptor containing request and response types */
  protoDescriptor: Uint8Array;
  /** (only for PROTO endpoints) Request proto message type name */
  requestType: string;
  /** (only for PROTO endpoints) Response proto message type name */
  responseType: string;
  /** (only for internal API endpoints) Whether the API uses internal proxy to get user location */
  usesLocationProxy: boolean;
  /** Caching config */
  cachingConfig:
    | RemoteApiCachingConfig
    | undefined;
  /** (only for internal API endpoints) User location use case */
  userLocationUseCase: UserLocationUseCase;
  /** Endpoint documentation link (optional) */
  documentationLink: string;
  /** Endpoint use case description (optional) */
  description: string;
  /** (only for PROTO endpoints) Used to configure visibility/macros of response proto fields */
  responseParameters: RemoteApiHttpResponseParameter[];
  /**
   * Validate body through Abuse Language Detection service before making request
   *
   * @deprecated
   */
  reqAldRequestValidation: boolean;
  /**
   * Validate body through Abuse Language Detection service before returning response
   *
   * @deprecated
   */
  reqAldResponseValidation: boolean;
  /** Which ALD context window to use for validation */
  aldContextWindow: string;
  /** Which types of content in the request to run through ALD */
  aldRequestConfigs: AldRequestValidationConfig[];
  /** Which types of content in the response to run through ALD */
  aldResponseConfigs: AldResponseValidationConfig[];
}

/** Possible HTTP request method on an endpoint */
export enum RemoteApiHttpEndpoint_HttpRequestMethod {
  /** METHOD_UNSET - Undefined method */
  METHOD_UNSET = "METHOD_UNSET",
  /** GET - HTTP GET */
  GET = "GET",
  /** POST - HTTP POST */
  POST = "POST",
  /** PUT - HTTP PUT */
  PUT = "PUT",
  /** DELETE - HTTP DELETE */
  DELETE = "DELETE",
  /** PATCH - HTTP PATCH */
  PATCH = "PATCH",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiHttpEndpoint_HttpRequestMethodFromJSON(object: any): RemoteApiHttpEndpoint_HttpRequestMethod {
  switch (object) {
    case 0:
    case "METHOD_UNSET":
      return RemoteApiHttpEndpoint_HttpRequestMethod.METHOD_UNSET;
    case 1:
    case "GET":
      return RemoteApiHttpEndpoint_HttpRequestMethod.GET;
    case 2:
    case "POST":
      return RemoteApiHttpEndpoint_HttpRequestMethod.POST;
    case 3:
    case "PUT":
      return RemoteApiHttpEndpoint_HttpRequestMethod.PUT;
    case 4:
    case "DELETE":
      return RemoteApiHttpEndpoint_HttpRequestMethod.DELETE;
    case 5:
    case "PATCH":
      return RemoteApiHttpEndpoint_HttpRequestMethod.PATCH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiHttpEndpoint_HttpRequestMethod.UNRECOGNIZED;
  }
}

export function remoteApiHttpEndpoint_HttpRequestMethodToNumber(
  object: RemoteApiHttpEndpoint_HttpRequestMethod,
): number {
  switch (object) {
    case RemoteApiHttpEndpoint_HttpRequestMethod.METHOD_UNSET:
      return 0;
    case RemoteApiHttpEndpoint_HttpRequestMethod.GET:
      return 1;
    case RemoteApiHttpEndpoint_HttpRequestMethod.POST:
      return 2;
    case RemoteApiHttpEndpoint_HttpRequestMethod.PUT:
      return 3;
    case RemoteApiHttpEndpoint_HttpRequestMethod.DELETE:
      return 4;
    case RemoteApiHttpEndpoint_HttpRequestMethod.PATCH:
      return 5;
    case RemoteApiHttpEndpoint_HttpRequestMethod.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Defines a remote API gRPC endpoint */
export interface RemoteApiGrpcEndpoint {
  /** Symbol of target method in the format of package.service.method */
  methodSymbol: string;
  /** ID used by clients to refer to this endpoint */
  refId: string;
  /** Request proto message type name */
  requestType: string;
  /** Response proto message type name */
  responseType: string;
  /** (only for internal API endpoints) Whether the API uses internal proxy to get user location */
  usesLocationProxy: boolean;
  /** (only for internal API endpoints) User location use case */
  userLocationUseCase: UserLocationUseCase;
  /** Endpoint documentation link (optional) */
  documentationLink: string;
  /** Endpoint use case description (optional) */
  description: string;
  /** Used to configure visibility/macros of response proto fields */
  responseParameters: RemoteApiGrpcResponseParameter[];
  /** Serialized protobuf descriptor containing request and response types */
  protoDescriptor: Uint8Array;
  /** Request parameters for this gRPC endpoint (used to configure macros/optional fields) */
  requestParameters: RemoteApiGrpcRequestParameter[];
}

/** Represents names of fields in a proto response, as well as an optional macro value */
export interface RemoteApiGrpcResponseParameter {
  /** Unique name of the parameter */
  name: string;
  /** Whether or not we want to expose this parameter in the final API response to user */
  hidden: boolean;
  /** Specific macro values indicate certain parameters and types that we want to map this proto field to. */
  macroValue: string;
}

/** Defines how a parameter is injected into an gRPC request */
export interface RemoteApiGrpcRequestParameter {
  /** Unique name of the parameter */
  name: string;
  /** Is parameter optional */
  optional: boolean;
  /**
   * Default value if the parameter is not set. Useful for "standard" headers like content-type
   * and other similar cases. If a default value is provided, the parameter will be sent with every request.
   * Required for constant parameters.
   */
  defaultValue: string;
  /**
   * Constant parameters have the same predefined value for all requests and
   * are always set by the proxy. Not allowed to be overridden by the caller.
   */
  constant: boolean;
}

/** Defines OAuth2-related configuration for a remote API */
export interface RemoteApiOAuth2Config {
  /** OAuth2 client identifier: https://tools.ietf.org/html/rfc6749#section-2.2 */
  clientId: string;
  /** OAuth2 grant type required for the remote API */
  grantType: RemoteApiOAuth2Config_GrantType;
  /** https://tools.ietf.org/html/rfc6749#section-3.1 */
  authorizationUrl: string;
  /** https://tools.ietf.org/html/rfc6749#section-3.2 */
  tokenUrl: string;
  /** https://tools.ietf.org/html/rfc6749#section-3.3 */
  scope: string;
  /** https://datatracker.ietf.org/doc/html/rfc6749#section-2.3.1 */
  clientSecret: string;
}

/** OAuth2 grant types supported by the remote-service feature */
export enum RemoteApiOAuth2Config_GrantType {
  /** GRANT_TYPE_UNSET - Undefined grant type */
  GRANT_TYPE_UNSET = "GRANT_TYPE_UNSET",
  /** AUTHORIZATION_CODE - https://datatracker.ietf.org/doc/html/rfc6749#section-4.1 */
  AUTHORIZATION_CODE = "AUTHORIZATION_CODE",
  /** AUTHORIZATION_CODE_WITH_PKCE - https://tools.ietf.org/html/rfc7636 */
  AUTHORIZATION_CODE_WITH_PKCE = "AUTHORIZATION_CODE_WITH_PKCE",
  /** IMPLICIT - https://tools.ietf.org/html/rfc6749#section-4.2 */
  IMPLICIT = "IMPLICIT",
  /** CLIENT_CREDENTIALS - https://tools.ietf.org/html/rfc6749#section-4.4 */
  CLIENT_CREDENTIALS = "CLIENT_CREDENTIALS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiOAuth2Config_GrantTypeFromJSON(object: any): RemoteApiOAuth2Config_GrantType {
  switch (object) {
    case 0:
    case "GRANT_TYPE_UNSET":
      return RemoteApiOAuth2Config_GrantType.GRANT_TYPE_UNSET;
    case 1:
    case "AUTHORIZATION_CODE":
      return RemoteApiOAuth2Config_GrantType.AUTHORIZATION_CODE;
    case 2:
    case "AUTHORIZATION_CODE_WITH_PKCE":
      return RemoteApiOAuth2Config_GrantType.AUTHORIZATION_CODE_WITH_PKCE;
    case 3:
    case "IMPLICIT":
      return RemoteApiOAuth2Config_GrantType.IMPLICIT;
    case 4:
    case "CLIENT_CREDENTIALS":
      return RemoteApiOAuth2Config_GrantType.CLIENT_CREDENTIALS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiOAuth2Config_GrantType.UNRECOGNIZED;
  }
}

export function remoteApiOAuth2Config_GrantTypeToNumber(object: RemoteApiOAuth2Config_GrantType): number {
  switch (object) {
    case RemoteApiOAuth2Config_GrantType.GRANT_TYPE_UNSET:
      return 0;
    case RemoteApiOAuth2Config_GrantType.AUTHORIZATION_CODE:
      return 1;
    case RemoteApiOAuth2Config_GrantType.AUTHORIZATION_CODE_WITH_PKCE:
      return 2;
    case RemoteApiOAuth2Config_GrantType.IMPLICIT:
      return 3;
    case RemoteApiOAuth2Config_GrantType.CLIENT_CREDENTIALS:
      return 4;
    case RemoteApiOAuth2Config_GrantType.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Defines security-related configuration of a remote API */
export interface RemoteApiSecurityConfig {
  /** Security scheme of the remote API */
  securityScheme: RemoteApiSecurityConfig_SecurityScheme;
  configs?:
    | { $case: "apiKeyParam"; apiKeyParam: RemoteApiHttpRequestParameter }
    | { $case: "oauth2Config"; oauth2Config: RemoteApiOAuth2Config }
    | { $case: "apiKeyConfig"; apiKeyConfig: RemoteApiKeyConfig }
    | undefined;
}

/** Possible security schemes for a remote API */
export enum RemoteApiSecurityConfig_SecurityScheme {
  /** SCHEME_UNSET - Undefined scheme */
  SCHEME_UNSET = "SCHEME_UNSET",
  /** NONE - No authentication is required */
  NONE = "NONE",
  /** SNAP_TOKEN - Internal snap services using snap token */
  SNAP_TOKEN = "SNAP_TOKEN",
  /** API_KEY - API that requires an api key */
  API_KEY = "API_KEY",
  /** OAUTH2 - API that requires OAuth2 */
  OAUTH2 = "OAUTH2",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function remoteApiSecurityConfig_SecuritySchemeFromJSON(object: any): RemoteApiSecurityConfig_SecurityScheme {
  switch (object) {
    case 0:
    case "SCHEME_UNSET":
      return RemoteApiSecurityConfig_SecurityScheme.SCHEME_UNSET;
    case 1:
    case "NONE":
      return RemoteApiSecurityConfig_SecurityScheme.NONE;
    case 2:
    case "SNAP_TOKEN":
      return RemoteApiSecurityConfig_SecurityScheme.SNAP_TOKEN;
    case 3:
    case "API_KEY":
      return RemoteApiSecurityConfig_SecurityScheme.API_KEY;
    case 4:
    case "OAUTH2":
      return RemoteApiSecurityConfig_SecurityScheme.OAUTH2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RemoteApiSecurityConfig_SecurityScheme.UNRECOGNIZED;
  }
}

export function remoteApiSecurityConfig_SecuritySchemeToNumber(object: RemoteApiSecurityConfig_SecurityScheme): number {
  switch (object) {
    case RemoteApiSecurityConfig_SecurityScheme.SCHEME_UNSET:
      return 0;
    case RemoteApiSecurityConfig_SecurityScheme.NONE:
      return 1;
    case RemoteApiSecurityConfig_SecurityScheme.SNAP_TOKEN:
      return 2;
    case RemoteApiSecurityConfig_SecurityScheme.API_KEY:
      return 3;
    case RemoteApiSecurityConfig_SecurityScheme.OAUTH2:
      return 4;
    case RemoteApiSecurityConfig_SecurityScheme.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Defines an API key-based security config */
export interface RemoteApiKeyConfig {
  /** Parameters through which secrets are provided to the API */
  params: RemoteApiHttpRequestParameter[];
  /** Secret values fetched from storage, keyed by param name */
  secretValues: { [key: string]: string };
}

export interface RemoteApiKeyConfig_SecretValuesEntry {
  key: string;
  value: string;
}

/** Remote API spec metadata for internal usage */
export interface RemoteApiSpecMetadata {
  /** Human-readable name of the spec */
  name: string;
  /** Who created the spec (email) */
  author: string;
  /** When the spec was created (UTC timestamp) */
  creationTimeSec: string;
  /** When the spec was last edited (UTC timestamp) */
  lastEditTimeSec: string;
  /** Who last edited the spec (email) */
  lastEditor: string;
  /** When the spec was last reviewed (UTC timestamp) */
  reviewTimeSec: string;
  /** Who last reviewed the spec (email) */
  reviewer: string;
  /**
   * ID of the secret that contains they API key(s) or other authentication data
   * in Spookey or another secret storage
   */
  secretId: string;
  /** ID of the API spec, from which this one was derived (if any) */
  derivedFromSpecId: string;
  /** Where was this API spec created from */
  createdFrom: CreatedFrom;
  /** URL containing the icon of the API (e.g. in Bolt) */
  iconUrl: string;
  /** Company or person providing the API */
  providerName: string;
  /** Textual description for the API that may include links to documentation, etc. */
  description: string;
  /** Link to API documentation */
  documentationUrl: string;
  /** Link to internal quip documenting the API */
  internalApiQuipUrl: string;
  /** Spec version */
  version: string;
}

/** Defines a remote service with a list of endpoints and a single security configuration */
export interface RemoteApiSpec {
  /** ID of the API spec */
  id: string;
  /** List of HTTP endpoints allowed by this API spec */
  endpoints: RemoteApiHttpEndpoint[];
  /** Security configuration of this API spec */
  securityConfig:
    | RemoteApiSecurityConfig
    | undefined;
  /** Hostname or hostname and port in format of host:port */
  host: string;
  /** Defines if secured connection (HTTPS) must be forced */
  tlsRequired: boolean;
  /** Specifies caller's max request size in bytes for any of defined endpoints (optional value) */
  maxRequestSizeBytes: number;
  /** Specifies calle's max response size in bytes for any of defined endpoints (optional value) */
  maxResponseSizeBytes: number;
  /** Specifies calle's max response time in millis for any of defined endpoints (optional value) */
  maxResponseTimeMillis: number;
  /** Approval state of the spec */
  approvalState: SpecApprovalState;
  /** Visibility of the spec */
  visibility: SpecVisibility;
  /** Metadata */
  metadata:
    | RemoteApiSpecMetadata
    | undefined;
  /** Target platform of the spec */
  targetPlatforms: TargetPlatform[];
  /** List of user IDs that are given visibility to a spec (optional value) */
  customVisibilityUsers: string[];
  /** Whether or not this API actually goes through the remote-api service vs a local client handler (camera kit for example) */
  localOnly: boolean;
  /** Approximate (within 1d) time that the spec was last accessed (UTC timestamp) */
  lastAccessTimeSec: string;
  /** List of permissions. Empty list indicates no permission is granted. */
  restrictedJsApiPermissions: RestrictedJsApiPermission[];
  /** Minimum Lens Studio version that this spec will be shown in. (e.g. "4.10.0.0") */
  minLensStudioVersion: string;
  /** Whether or not this spec is restricted from being used in a sponsored lens */
  sponsoredLensRestricted: boolean;
  /** List of user IDs that are given edit permissions to a spec (optional value) */
  editPermissionUsers: string[];
  /** List of gRPC endpoints allowed by this API spec */
  grpcEndpoints: RemoteApiGrpcEndpoint[];
  /** (CameraKit Only) Snap Kit app ID is a metadata field that associates the spec with camera kit app */
  snapkitAppId: string;
  /** (CameraKit Only) - Whether this API uses the Camera Kit built-in local processor or the processor provided by a Camera Kit partner */
  useBuiltinLocalProcessor: boolean;
  /** An id of organization who own the spec */
  orgId: string;
  /** Whether or not we allow link redirects (needs to be trusted API source) */
  allowRedirects: boolean;
}

/** [Deprecated] Remote API spec set metadata for internal usage (services within Snap) */
export interface RemoteApiSpecSetMetadata {
  /** Human-readable name of the API (e.g. "Weather API") */
  name: string;
  /** URL containing the icon of the API (e.g. in Bolt) */
  iconUrl: string;
  /** Company or person providing the API */
  providerName: string;
  /** Textual description for the API that may include links to documentation, etc. */
  description: string;
  /** Who created the spec set (email) */
  author: string;
  /** When the spec set was created (UTC timestamp) */
  creationTimeSec: string;
  /** When the spec set was last edited (UTC timestamp) */
  lastEditTimeSec: string;
  /** Who last edited the spec set (email) */
  lastEditor: string;
  /** Link to API documentation */
  documentationUrl: string;
  /** Where was this API spec created from */
  createdFrom: CreatedFrom;
}

/** [Deprecated] Defines a remote API as a collection of services that are meant to be used together */
export interface RemoteApiSpecSet {
  /** ID of the spec set */
  id: string;
  /** Service specifications */
  specs: RemoteApiSpec[];
  /** Metadata */
  metadata:
    | RemoteApiSpecSetMetadata
    | undefined;
  /** Approximate (within 1d) time that the spec was last accessed (UTC timestamp) */
  lastAccessTimeSec: string;
}

function createBaseRemoteApiHttpRequestParameter(): RemoteApiHttpRequestParameter {
  return {
    name: "",
    location: RemoteApiHttpRequestParameter_ParameterLocation.LOCATION_UNSET,
    optional: false,
    externalName: "",
    defaultValue: "",
    constant: false,
  };
}

export const RemoteApiHttpRequestParameter: MessageFns<RemoteApiHttpRequestParameter> = {
  encode(message: RemoteApiHttpRequestParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.location !== RemoteApiHttpRequestParameter_ParameterLocation.LOCATION_UNSET) {
      writer.uint32(16).int32(remoteApiHttpRequestParameter_ParameterLocationToNumber(message.location));
    }
    if (message.optional !== false) {
      writer.uint32(24).bool(message.optional);
    }
    if (message.externalName !== "") {
      writer.uint32(34).string(message.externalName);
    }
    if (message.defaultValue !== "") {
      writer.uint32(42).string(message.defaultValue);
    }
    if (message.constant !== false) {
      writer.uint32(48).bool(message.constant);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiHttpRequestParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiHttpRequestParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.location = remoteApiHttpRequestParameter_ParameterLocationFromJSON(reader.int32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.optional = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.externalName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.defaultValue = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.constant = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiHttpRequestParameter>, I>>(base?: I): RemoteApiHttpRequestParameter {
    return RemoteApiHttpRequestParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiHttpRequestParameter>, I>>(
    object: I,
  ): RemoteApiHttpRequestParameter {
    const message = createBaseRemoteApiHttpRequestParameter();
    message.name = object.name ?? "";
    message.location = object.location ?? RemoteApiHttpRequestParameter_ParameterLocation.LOCATION_UNSET;
    message.optional = object.optional ?? false;
    message.externalName = object.externalName ?? "";
    message.defaultValue = object.defaultValue ?? "";
    message.constant = object.constant ?? false;
    return message;
  },
};

function createBaseRemoteApiHttpResponseParameter(): RemoteApiHttpResponseParameter {
  return { name: "", hidden: false, macroValue: "" };
}

export const RemoteApiHttpResponseParameter: MessageFns<RemoteApiHttpResponseParameter> = {
  encode(message: RemoteApiHttpResponseParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.hidden !== false) {
      writer.uint32(16).bool(message.hidden);
    }
    if (message.macroValue !== "") {
      writer.uint32(26).string(message.macroValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiHttpResponseParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiHttpResponseParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.macroValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiHttpResponseParameter>, I>>(base?: I): RemoteApiHttpResponseParameter {
    return RemoteApiHttpResponseParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiHttpResponseParameter>, I>>(
    object: I,
  ): RemoteApiHttpResponseParameter {
    const message = createBaseRemoteApiHttpResponseParameter();
    message.name = object.name ?? "";
    message.hidden = object.hidden ?? false;
    message.macroValue = object.macroValue ?? "";
    return message;
  },
};

function createBaseRemoteApiEndpointMetadata(): RemoteApiEndpointMetadata {
  return { name: "", description: "" };
}

export const RemoteApiEndpointMetadata: MessageFns<RemoteApiEndpointMetadata> = {
  encode(message: RemoteApiEndpointMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(18).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiEndpointMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiEndpointMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiEndpointMetadata>, I>>(base?: I): RemoteApiEndpointMetadata {
    return RemoteApiEndpointMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiEndpointMetadata>, I>>(object: I): RemoteApiEndpointMetadata {
    const message = createBaseRemoteApiEndpointMetadata();
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    return message;
  },
};

function createBaseRemoteApiCachingConfig(): RemoteApiCachingConfig {
  return {
    cacheStrategy: RemoteApiCacheStrategy.CS_UNSET,
    ttlStrategy: RemoteApiCacheTTLStrategy.CTS_UNSET,
    ttlSec: "0",
  };
}

export const RemoteApiCachingConfig: MessageFns<RemoteApiCachingConfig> = {
  encode(message: RemoteApiCachingConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cacheStrategy !== RemoteApiCacheStrategy.CS_UNSET) {
      writer.uint32(8).int32(remoteApiCacheStrategyToNumber(message.cacheStrategy));
    }
    if (message.ttlStrategy !== RemoteApiCacheTTLStrategy.CTS_UNSET) {
      writer.uint32(16).int32(remoteApiCacheTTLStrategyToNumber(message.ttlStrategy));
    }
    if (message.ttlSec !== "0") {
      writer.uint32(24).int64(message.ttlSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiCachingConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiCachingConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.cacheStrategy = remoteApiCacheStrategyFromJSON(reader.int32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.ttlStrategy = remoteApiCacheTTLStrategyFromJSON(reader.int32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.ttlSec = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiCachingConfig>, I>>(base?: I): RemoteApiCachingConfig {
    return RemoteApiCachingConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiCachingConfig>, I>>(object: I): RemoteApiCachingConfig {
    const message = createBaseRemoteApiCachingConfig();
    message.cacheStrategy = object.cacheStrategy ?? RemoteApiCacheStrategy.CS_UNSET;
    message.ttlStrategy = object.ttlStrategy ?? RemoteApiCacheTTLStrategy.CTS_UNSET;
    message.ttlSec = object.ttlSec ?? "0";
    return message;
  },
};

function createBaseRemoteApiHttpEndpoint(): RemoteApiHttpEndpoint {
  return {
    path: "",
    methods: [],
    parameters: [],
    metadata: undefined,
    refId: "",
    type: RemoteApiEndpointType.TYPE_UNSET,
    protoDescriptor: new Uint8Array(0),
    requestType: "",
    responseType: "",
    usesLocationProxy: false,
    cachingConfig: undefined,
    userLocationUseCase: UserLocationUseCase.USE_CASE_UNSET,
    documentationLink: "",
    description: "",
    responseParameters: [],
    reqAldRequestValidation: false,
    reqAldResponseValidation: false,
    aldContextWindow: "",
    aldRequestConfigs: [],
    aldResponseConfigs: [],
  };
}

export const RemoteApiHttpEndpoint: MessageFns<RemoteApiHttpEndpoint> = {
  encode(message: RemoteApiHttpEndpoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.path !== "") {
      writer.uint32(10).string(message.path);
    }
    writer.uint32(18).fork();
    for (const v of message.methods) {
      writer.int32(remoteApiHttpEndpoint_HttpRequestMethodToNumber(v));
    }
    writer.join();
    for (const v of message.parameters) {
      RemoteApiHttpRequestParameter.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.metadata !== undefined) {
      RemoteApiEndpointMetadata.encode(message.metadata, writer.uint32(34).fork()).join();
    }
    if (message.refId !== "") {
      writer.uint32(42).string(message.refId);
    }
    if (message.type !== RemoteApiEndpointType.TYPE_UNSET) {
      writer.uint32(48).int32(remoteApiEndpointTypeToNumber(message.type));
    }
    if (message.protoDescriptor.length !== 0) {
      writer.uint32(58).bytes(message.protoDescriptor);
    }
    if (message.requestType !== "") {
      writer.uint32(66).string(message.requestType);
    }
    if (message.responseType !== "") {
      writer.uint32(74).string(message.responseType);
    }
    if (message.usesLocationProxy !== false) {
      writer.uint32(80).bool(message.usesLocationProxy);
    }
    if (message.cachingConfig !== undefined) {
      RemoteApiCachingConfig.encode(message.cachingConfig, writer.uint32(90).fork()).join();
    }
    if (message.userLocationUseCase !== UserLocationUseCase.USE_CASE_UNSET) {
      writer.uint32(96).int32(userLocationUseCaseToNumber(message.userLocationUseCase));
    }
    if (message.documentationLink !== "") {
      writer.uint32(106).string(message.documentationLink);
    }
    if (message.description !== "") {
      writer.uint32(114).string(message.description);
    }
    for (const v of message.responseParameters) {
      RemoteApiHttpResponseParameter.encode(v!, writer.uint32(122).fork()).join();
    }
    if (message.reqAldRequestValidation !== false) {
      writer.uint32(128).bool(message.reqAldRequestValidation);
    }
    if (message.reqAldResponseValidation !== false) {
      writer.uint32(136).bool(message.reqAldResponseValidation);
    }
    if (message.aldContextWindow !== "") {
      writer.uint32(146).string(message.aldContextWindow);
    }
    writer.uint32(154).fork();
    for (const v of message.aldRequestConfigs) {
      writer.int32(aldRequestValidationConfigToNumber(v));
    }
    writer.join();
    writer.uint32(162).fork();
    for (const v of message.aldResponseConfigs) {
      writer.int32(aldResponseValidationConfigToNumber(v));
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiHttpEndpoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiHttpEndpoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.path = reader.string();
          continue;
        }
        case 2: {
          if (tag === 16) {
            message.methods.push(remoteApiHttpEndpoint_HttpRequestMethodFromJSON(reader.int32()));

            continue;
          }

          if (tag === 18) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.methods.push(remoteApiHttpEndpoint_HttpRequestMethodFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.parameters.push(RemoteApiHttpRequestParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata = RemoteApiEndpointMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.refId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.type = remoteApiEndpointTypeFromJSON(reader.int32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.protoDescriptor = reader.bytes();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.requestType = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.responseType = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.usesLocationProxy = reader.bool();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.cachingConfig = RemoteApiCachingConfig.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.userLocationUseCase = userLocationUseCaseFromJSON(reader.int32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.documentationLink = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.responseParameters.push(RemoteApiHttpResponseParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.reqAldRequestValidation = reader.bool();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.reqAldResponseValidation = reader.bool();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.aldContextWindow = reader.string();
          continue;
        }
        case 19: {
          if (tag === 152) {
            message.aldRequestConfigs.push(aldRequestValidationConfigFromJSON(reader.int32()));

            continue;
          }

          if (tag === 154) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.aldRequestConfigs.push(aldRequestValidationConfigFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
        case 20: {
          if (tag === 160) {
            message.aldResponseConfigs.push(aldResponseValidationConfigFromJSON(reader.int32()));

            continue;
          }

          if (tag === 162) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.aldResponseConfigs.push(aldResponseValidationConfigFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiHttpEndpoint>, I>>(base?: I): RemoteApiHttpEndpoint {
    return RemoteApiHttpEndpoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiHttpEndpoint>, I>>(object: I): RemoteApiHttpEndpoint {
    const message = createBaseRemoteApiHttpEndpoint();
    message.path = object.path ?? "";
    message.methods = object.methods?.map((e) => e) || [];
    message.parameters = object.parameters?.map((e) => RemoteApiHttpRequestParameter.fromPartial(e)) || [];
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? RemoteApiEndpointMetadata.fromPartial(object.metadata)
      : undefined;
    message.refId = object.refId ?? "";
    message.type = object.type ?? RemoteApiEndpointType.TYPE_UNSET;
    message.protoDescriptor = object.protoDescriptor ?? new Uint8Array(0);
    message.requestType = object.requestType ?? "";
    message.responseType = object.responseType ?? "";
    message.usesLocationProxy = object.usesLocationProxy ?? false;
    message.cachingConfig = (object.cachingConfig !== undefined && object.cachingConfig !== null)
      ? RemoteApiCachingConfig.fromPartial(object.cachingConfig)
      : undefined;
    message.userLocationUseCase = object.userLocationUseCase ?? UserLocationUseCase.USE_CASE_UNSET;
    message.documentationLink = object.documentationLink ?? "";
    message.description = object.description ?? "";
    message.responseParameters = object.responseParameters?.map((e) => RemoteApiHttpResponseParameter.fromPartial(e)) ||
      [];
    message.reqAldRequestValidation = object.reqAldRequestValidation ?? false;
    message.reqAldResponseValidation = object.reqAldResponseValidation ?? false;
    message.aldContextWindow = object.aldContextWindow ?? "";
    message.aldRequestConfigs = object.aldRequestConfigs?.map((e) => e) || [];
    message.aldResponseConfigs = object.aldResponseConfigs?.map((e) => e) || [];
    return message;
  },
};

function createBaseRemoteApiGrpcEndpoint(): RemoteApiGrpcEndpoint {
  return {
    methodSymbol: "",
    refId: "",
    requestType: "",
    responseType: "",
    usesLocationProxy: false,
    userLocationUseCase: UserLocationUseCase.USE_CASE_UNSET,
    documentationLink: "",
    description: "",
    responseParameters: [],
    protoDescriptor: new Uint8Array(0),
    requestParameters: [],
  };
}

export const RemoteApiGrpcEndpoint: MessageFns<RemoteApiGrpcEndpoint> = {
  encode(message: RemoteApiGrpcEndpoint, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.methodSymbol !== "") {
      writer.uint32(10).string(message.methodSymbol);
    }
    if (message.refId !== "") {
      writer.uint32(18).string(message.refId);
    }
    if (message.requestType !== "") {
      writer.uint32(26).string(message.requestType);
    }
    if (message.responseType !== "") {
      writer.uint32(34).string(message.responseType);
    }
    if (message.usesLocationProxy !== false) {
      writer.uint32(40).bool(message.usesLocationProxy);
    }
    if (message.userLocationUseCase !== UserLocationUseCase.USE_CASE_UNSET) {
      writer.uint32(48).int32(userLocationUseCaseToNumber(message.userLocationUseCase));
    }
    if (message.documentationLink !== "") {
      writer.uint32(58).string(message.documentationLink);
    }
    if (message.description !== "") {
      writer.uint32(66).string(message.description);
    }
    for (const v of message.responseParameters) {
      RemoteApiGrpcResponseParameter.encode(v!, writer.uint32(74).fork()).join();
    }
    if (message.protoDescriptor.length !== 0) {
      writer.uint32(82).bytes(message.protoDescriptor);
    }
    for (const v of message.requestParameters) {
      RemoteApiGrpcRequestParameter.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiGrpcEndpoint {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiGrpcEndpoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.methodSymbol = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.refId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.requestType = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.responseType = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.usesLocationProxy = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.userLocationUseCase = userLocationUseCaseFromJSON(reader.int32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.documentationLink = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.responseParameters.push(RemoteApiGrpcResponseParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.protoDescriptor = reader.bytes();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.requestParameters.push(RemoteApiGrpcRequestParameter.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiGrpcEndpoint>, I>>(base?: I): RemoteApiGrpcEndpoint {
    return RemoteApiGrpcEndpoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiGrpcEndpoint>, I>>(object: I): RemoteApiGrpcEndpoint {
    const message = createBaseRemoteApiGrpcEndpoint();
    message.methodSymbol = object.methodSymbol ?? "";
    message.refId = object.refId ?? "";
    message.requestType = object.requestType ?? "";
    message.responseType = object.responseType ?? "";
    message.usesLocationProxy = object.usesLocationProxy ?? false;
    message.userLocationUseCase = object.userLocationUseCase ?? UserLocationUseCase.USE_CASE_UNSET;
    message.documentationLink = object.documentationLink ?? "";
    message.description = object.description ?? "";
    message.responseParameters = object.responseParameters?.map((e) => RemoteApiGrpcResponseParameter.fromPartial(e)) ||
      [];
    message.protoDescriptor = object.protoDescriptor ?? new Uint8Array(0);
    message.requestParameters = object.requestParameters?.map((e) => RemoteApiGrpcRequestParameter.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseRemoteApiGrpcResponseParameter(): RemoteApiGrpcResponseParameter {
  return { name: "", hidden: false, macroValue: "" };
}

export const RemoteApiGrpcResponseParameter: MessageFns<RemoteApiGrpcResponseParameter> = {
  encode(message: RemoteApiGrpcResponseParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.hidden !== false) {
      writer.uint32(16).bool(message.hidden);
    }
    if (message.macroValue !== "") {
      writer.uint32(26).string(message.macroValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiGrpcResponseParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiGrpcResponseParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hidden = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.macroValue = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiGrpcResponseParameter>, I>>(base?: I): RemoteApiGrpcResponseParameter {
    return RemoteApiGrpcResponseParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiGrpcResponseParameter>, I>>(
    object: I,
  ): RemoteApiGrpcResponseParameter {
    const message = createBaseRemoteApiGrpcResponseParameter();
    message.name = object.name ?? "";
    message.hidden = object.hidden ?? false;
    message.macroValue = object.macroValue ?? "";
    return message;
  },
};

function createBaseRemoteApiGrpcRequestParameter(): RemoteApiGrpcRequestParameter {
  return { name: "", optional: false, defaultValue: "", constant: false };
}

export const RemoteApiGrpcRequestParameter: MessageFns<RemoteApiGrpcRequestParameter> = {
  encode(message: RemoteApiGrpcRequestParameter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.optional !== false) {
      writer.uint32(16).bool(message.optional);
    }
    if (message.defaultValue !== "") {
      writer.uint32(26).string(message.defaultValue);
    }
    if (message.constant !== false) {
      writer.uint32(32).bool(message.constant);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiGrpcRequestParameter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiGrpcRequestParameter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.optional = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.defaultValue = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.constant = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiGrpcRequestParameter>, I>>(base?: I): RemoteApiGrpcRequestParameter {
    return RemoteApiGrpcRequestParameter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiGrpcRequestParameter>, I>>(
    object: I,
  ): RemoteApiGrpcRequestParameter {
    const message = createBaseRemoteApiGrpcRequestParameter();
    message.name = object.name ?? "";
    message.optional = object.optional ?? false;
    message.defaultValue = object.defaultValue ?? "";
    message.constant = object.constant ?? false;
    return message;
  },
};

function createBaseRemoteApiOAuth2Config(): RemoteApiOAuth2Config {
  return {
    clientId: "",
    grantType: RemoteApiOAuth2Config_GrantType.GRANT_TYPE_UNSET,
    authorizationUrl: "",
    tokenUrl: "",
    scope: "",
    clientSecret: "",
  };
}

export const RemoteApiOAuth2Config: MessageFns<RemoteApiOAuth2Config> = {
  encode(message: RemoteApiOAuth2Config, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }
    if (message.grantType !== RemoteApiOAuth2Config_GrantType.GRANT_TYPE_UNSET) {
      writer.uint32(16).int32(remoteApiOAuth2Config_GrantTypeToNumber(message.grantType));
    }
    if (message.authorizationUrl !== "") {
      writer.uint32(26).string(message.authorizationUrl);
    }
    if (message.tokenUrl !== "") {
      writer.uint32(34).string(message.tokenUrl);
    }
    if (message.scope !== "") {
      writer.uint32(42).string(message.scope);
    }
    if (message.clientSecret !== "") {
      writer.uint32(50).string(message.clientSecret);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiOAuth2Config {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiOAuth2Config();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.grantType = remoteApiOAuth2Config_GrantTypeFromJSON(reader.int32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.authorizationUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tokenUrl = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scope = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.clientSecret = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiOAuth2Config>, I>>(base?: I): RemoteApiOAuth2Config {
    return RemoteApiOAuth2Config.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiOAuth2Config>, I>>(object: I): RemoteApiOAuth2Config {
    const message = createBaseRemoteApiOAuth2Config();
    message.clientId = object.clientId ?? "";
    message.grantType = object.grantType ?? RemoteApiOAuth2Config_GrantType.GRANT_TYPE_UNSET;
    message.authorizationUrl = object.authorizationUrl ?? "";
    message.tokenUrl = object.tokenUrl ?? "";
    message.scope = object.scope ?? "";
    message.clientSecret = object.clientSecret ?? "";
    return message;
  },
};

function createBaseRemoteApiSecurityConfig(): RemoteApiSecurityConfig {
  return { securityScheme: RemoteApiSecurityConfig_SecurityScheme.SCHEME_UNSET, configs: undefined };
}

export const RemoteApiSecurityConfig: MessageFns<RemoteApiSecurityConfig> = {
  encode(message: RemoteApiSecurityConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.securityScheme !== RemoteApiSecurityConfig_SecurityScheme.SCHEME_UNSET) {
      writer.uint32(8).int32(remoteApiSecurityConfig_SecuritySchemeToNumber(message.securityScheme));
    }
    switch (message.configs?.$case) {
      case "apiKeyParam":
        RemoteApiHttpRequestParameter.encode(message.configs.apiKeyParam, writer.uint32(18).fork()).join();
        break;
      case "oauth2Config":
        RemoteApiOAuth2Config.encode(message.configs.oauth2Config, writer.uint32(26).fork()).join();
        break;
      case "apiKeyConfig":
        RemoteApiKeyConfig.encode(message.configs.apiKeyConfig, writer.uint32(34).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiSecurityConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiSecurityConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.securityScheme = remoteApiSecurityConfig_SecuritySchemeFromJSON(reader.int32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.configs = {
            $case: "apiKeyParam",
            apiKeyParam: RemoteApiHttpRequestParameter.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.configs = {
            $case: "oauth2Config",
            oauth2Config: RemoteApiOAuth2Config.decode(reader, reader.uint32()),
          };
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.configs = { $case: "apiKeyConfig", apiKeyConfig: RemoteApiKeyConfig.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiSecurityConfig>, I>>(base?: I): RemoteApiSecurityConfig {
    return RemoteApiSecurityConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiSecurityConfig>, I>>(object: I): RemoteApiSecurityConfig {
    const message = createBaseRemoteApiSecurityConfig();
    message.securityScheme = object.securityScheme ?? RemoteApiSecurityConfig_SecurityScheme.SCHEME_UNSET;
    if (
      object.configs?.$case === "apiKeyParam" &&
      object.configs?.apiKeyParam !== undefined &&
      object.configs?.apiKeyParam !== null
    ) {
      message.configs = {
        $case: "apiKeyParam",
        apiKeyParam: RemoteApiHttpRequestParameter.fromPartial(object.configs.apiKeyParam),
      };
    }
    if (
      object.configs?.$case === "oauth2Config" &&
      object.configs?.oauth2Config !== undefined &&
      object.configs?.oauth2Config !== null
    ) {
      message.configs = {
        $case: "oauth2Config",
        oauth2Config: RemoteApiOAuth2Config.fromPartial(object.configs.oauth2Config),
      };
    }
    if (
      object.configs?.$case === "apiKeyConfig" &&
      object.configs?.apiKeyConfig !== undefined &&
      object.configs?.apiKeyConfig !== null
    ) {
      message.configs = {
        $case: "apiKeyConfig",
        apiKeyConfig: RemoteApiKeyConfig.fromPartial(object.configs.apiKeyConfig),
      };
    }
    return message;
  },
};

function createBaseRemoteApiKeyConfig(): RemoteApiKeyConfig {
  return { params: [], secretValues: {} };
}

export const RemoteApiKeyConfig: MessageFns<RemoteApiKeyConfig> = {
  encode(message: RemoteApiKeyConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.params) {
      RemoteApiHttpRequestParameter.encode(v!, writer.uint32(10).fork()).join();
    }
    Object.entries(message.secretValues).forEach(([key, value]) => {
      RemoteApiKeyConfig_SecretValuesEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiKeyConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiKeyConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.params.push(RemoteApiHttpRequestParameter.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = RemoteApiKeyConfig_SecretValuesEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.secretValues[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiKeyConfig>, I>>(base?: I): RemoteApiKeyConfig {
    return RemoteApiKeyConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiKeyConfig>, I>>(object: I): RemoteApiKeyConfig {
    const message = createBaseRemoteApiKeyConfig();
    message.params = object.params?.map((e) => RemoteApiHttpRequestParameter.fromPartial(e)) || [];
    message.secretValues = Object.entries(object.secretValues ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRemoteApiKeyConfig_SecretValuesEntry(): RemoteApiKeyConfig_SecretValuesEntry {
  return { key: "", value: "" };
}

export const RemoteApiKeyConfig_SecretValuesEntry: MessageFns<RemoteApiKeyConfig_SecretValuesEntry> = {
  encode(message: RemoteApiKeyConfig_SecretValuesEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiKeyConfig_SecretValuesEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiKeyConfig_SecretValuesEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiKeyConfig_SecretValuesEntry>, I>>(
    base?: I,
  ): RemoteApiKeyConfig_SecretValuesEntry {
    return RemoteApiKeyConfig_SecretValuesEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiKeyConfig_SecretValuesEntry>, I>>(
    object: I,
  ): RemoteApiKeyConfig_SecretValuesEntry {
    const message = createBaseRemoteApiKeyConfig_SecretValuesEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseRemoteApiSpecMetadata(): RemoteApiSpecMetadata {
  return {
    name: "",
    author: "",
    creationTimeSec: "0",
    lastEditTimeSec: "0",
    lastEditor: "",
    reviewTimeSec: "0",
    reviewer: "",
    secretId: "",
    derivedFromSpecId: "",
    createdFrom: CreatedFrom.CREATED_FROM_UNSET,
    iconUrl: "",
    providerName: "",
    description: "",
    documentationUrl: "",
    internalApiQuipUrl: "",
    version: "0",
  };
}

export const RemoteApiSpecMetadata: MessageFns<RemoteApiSpecMetadata> = {
  encode(message: RemoteApiSpecMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.author !== "") {
      writer.uint32(18).string(message.author);
    }
    if (message.creationTimeSec !== "0") {
      writer.uint32(24).int64(message.creationTimeSec);
    }
    if (message.lastEditTimeSec !== "0") {
      writer.uint32(32).int64(message.lastEditTimeSec);
    }
    if (message.lastEditor !== "") {
      writer.uint32(42).string(message.lastEditor);
    }
    if (message.reviewTimeSec !== "0") {
      writer.uint32(48).int64(message.reviewTimeSec);
    }
    if (message.reviewer !== "") {
      writer.uint32(58).string(message.reviewer);
    }
    if (message.secretId !== "") {
      writer.uint32(66).string(message.secretId);
    }
    if (message.derivedFromSpecId !== "") {
      writer.uint32(74).string(message.derivedFromSpecId);
    }
    if (message.createdFrom !== CreatedFrom.CREATED_FROM_UNSET) {
      writer.uint32(80).int32(createdFromToNumber(message.createdFrom));
    }
    if (message.iconUrl !== "") {
      writer.uint32(90).string(message.iconUrl);
    }
    if (message.providerName !== "") {
      writer.uint32(98).string(message.providerName);
    }
    if (message.description !== "") {
      writer.uint32(106).string(message.description);
    }
    if (message.documentationUrl !== "") {
      writer.uint32(114).string(message.documentationUrl);
    }
    if (message.internalApiQuipUrl !== "") {
      writer.uint32(122).string(message.internalApiQuipUrl);
    }
    if (message.version !== "0") {
      writer.uint32(128).int64(message.version);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiSpecMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiSpecMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.author = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.creationTimeSec = reader.int64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lastEditTimeSec = reader.int64().toString();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.lastEditor = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.reviewTimeSec = reader.int64().toString();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.reviewer = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.secretId = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.derivedFromSpecId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.createdFrom = createdFromFromJSON(reader.int32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.iconUrl = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.providerName = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.documentationUrl = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.internalApiQuipUrl = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.version = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiSpecMetadata>, I>>(base?: I): RemoteApiSpecMetadata {
    return RemoteApiSpecMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiSpecMetadata>, I>>(object: I): RemoteApiSpecMetadata {
    const message = createBaseRemoteApiSpecMetadata();
    message.name = object.name ?? "";
    message.author = object.author ?? "";
    message.creationTimeSec = object.creationTimeSec ?? "0";
    message.lastEditTimeSec = object.lastEditTimeSec ?? "0";
    message.lastEditor = object.lastEditor ?? "";
    message.reviewTimeSec = object.reviewTimeSec ?? "0";
    message.reviewer = object.reviewer ?? "";
    message.secretId = object.secretId ?? "";
    message.derivedFromSpecId = object.derivedFromSpecId ?? "";
    message.createdFrom = object.createdFrom ?? CreatedFrom.CREATED_FROM_UNSET;
    message.iconUrl = object.iconUrl ?? "";
    message.providerName = object.providerName ?? "";
    message.description = object.description ?? "";
    message.documentationUrl = object.documentationUrl ?? "";
    message.internalApiQuipUrl = object.internalApiQuipUrl ?? "";
    message.version = object.version ?? "0";
    return message;
  },
};

function createBaseRemoteApiSpec(): RemoteApiSpec {
  return {
    id: "",
    endpoints: [],
    securityConfig: undefined,
    host: "",
    tlsRequired: false,
    maxRequestSizeBytes: 0,
    maxResponseSizeBytes: 0,
    maxResponseTimeMillis: 0,
    approvalState: SpecApprovalState.APPROVAL_STATE_UNSET,
    visibility: SpecVisibility.VISIBILITY_UNSET,
    metadata: undefined,
    targetPlatforms: [],
    customVisibilityUsers: [],
    localOnly: false,
    lastAccessTimeSec: "0",
    restrictedJsApiPermissions: [],
    minLensStudioVersion: "",
    sponsoredLensRestricted: false,
    editPermissionUsers: [],
    grpcEndpoints: [],
    snapkitAppId: "",
    useBuiltinLocalProcessor: false,
    orgId: "",
    allowRedirects: false,
  };
}

export const RemoteApiSpec: MessageFns<RemoteApiSpec> = {
  encode(message: RemoteApiSpec, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.endpoints) {
      RemoteApiHttpEndpoint.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.securityConfig !== undefined) {
      RemoteApiSecurityConfig.encode(message.securityConfig, writer.uint32(26).fork()).join();
    }
    if (message.host !== "") {
      writer.uint32(34).string(message.host);
    }
    if (message.tlsRequired !== false) {
      writer.uint32(40).bool(message.tlsRequired);
    }
    if (message.maxRequestSizeBytes !== 0) {
      writer.uint32(48).int32(message.maxRequestSizeBytes);
    }
    if (message.maxResponseSizeBytes !== 0) {
      writer.uint32(56).int32(message.maxResponseSizeBytes);
    }
    if (message.maxResponseTimeMillis !== 0) {
      writer.uint32(64).int32(message.maxResponseTimeMillis);
    }
    if (message.approvalState !== SpecApprovalState.APPROVAL_STATE_UNSET) {
      writer.uint32(72).int32(specApprovalStateToNumber(message.approvalState));
    }
    if (message.visibility !== SpecVisibility.VISIBILITY_UNSET) {
      writer.uint32(80).int32(specVisibilityToNumber(message.visibility));
    }
    if (message.metadata !== undefined) {
      RemoteApiSpecMetadata.encode(message.metadata, writer.uint32(90).fork()).join();
    }
    writer.uint32(98).fork();
    for (const v of message.targetPlatforms) {
      writer.int32(targetPlatformToNumber(v));
    }
    writer.join();
    for (const v of message.customVisibilityUsers) {
      writer.uint32(106).string(v!);
    }
    if (message.localOnly !== false) {
      writer.uint32(112).bool(message.localOnly);
    }
    if (message.lastAccessTimeSec !== "0") {
      writer.uint32(120).int64(message.lastAccessTimeSec);
    }
    writer.uint32(130).fork();
    for (const v of message.restrictedJsApiPermissions) {
      writer.int32(restrictedJsApiPermissionToNumber(v));
    }
    writer.join();
    if (message.minLensStudioVersion !== "") {
      writer.uint32(138).string(message.minLensStudioVersion);
    }
    if (message.sponsoredLensRestricted !== false) {
      writer.uint32(144).bool(message.sponsoredLensRestricted);
    }
    for (const v of message.editPermissionUsers) {
      writer.uint32(154).string(v!);
    }
    for (const v of message.grpcEndpoints) {
      RemoteApiGrpcEndpoint.encode(v!, writer.uint32(162).fork()).join();
    }
    if (message.snapkitAppId !== "") {
      writer.uint32(170).string(message.snapkitAppId);
    }
    if (message.useBuiltinLocalProcessor !== false) {
      writer.uint32(176).bool(message.useBuiltinLocalProcessor);
    }
    if (message.orgId !== "") {
      writer.uint32(186).string(message.orgId);
    }
    if (message.allowRedirects !== false) {
      writer.uint32(192).bool(message.allowRedirects);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiSpec {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiSpec();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.endpoints.push(RemoteApiHttpEndpoint.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.securityConfig = RemoteApiSecurityConfig.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.host = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.tlsRequired = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.maxRequestSizeBytes = reader.int32();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.maxResponseSizeBytes = reader.int32();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.maxResponseTimeMillis = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.approvalState = specApprovalStateFromJSON(reader.int32());
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.visibility = specVisibilityFromJSON(reader.int32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.metadata = RemoteApiSpecMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag === 96) {
            message.targetPlatforms.push(targetPlatformFromJSON(reader.int32()));

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.targetPlatforms.push(targetPlatformFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.customVisibilityUsers.push(reader.string());
          continue;
        }
        case 14: {
          if (tag !== 112) {
            break;
          }

          message.localOnly = reader.bool();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.lastAccessTimeSec = reader.int64().toString();
          continue;
        }
        case 16: {
          if (tag === 128) {
            message.restrictedJsApiPermissions.push(restrictedJsApiPermissionFromJSON(reader.int32()));

            continue;
          }

          if (tag === 130) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.restrictedJsApiPermissions.push(restrictedJsApiPermissionFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.minLensStudioVersion = reader.string();
          continue;
        }
        case 18: {
          if (tag !== 144) {
            break;
          }

          message.sponsoredLensRestricted = reader.bool();
          continue;
        }
        case 19: {
          if (tag !== 154) {
            break;
          }

          message.editPermissionUsers.push(reader.string());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.grpcEndpoints.push(RemoteApiGrpcEndpoint.decode(reader, reader.uint32()));
          continue;
        }
        case 21: {
          if (tag !== 170) {
            break;
          }

          message.snapkitAppId = reader.string();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.useBuiltinLocalProcessor = reader.bool();
          continue;
        }
        case 23: {
          if (tag !== 186) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 24: {
          if (tag !== 192) {
            break;
          }

          message.allowRedirects = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiSpec>, I>>(base?: I): RemoteApiSpec {
    return RemoteApiSpec.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiSpec>, I>>(object: I): RemoteApiSpec {
    const message = createBaseRemoteApiSpec();
    message.id = object.id ?? "";
    message.endpoints = object.endpoints?.map((e) => RemoteApiHttpEndpoint.fromPartial(e)) || [];
    message.securityConfig = (object.securityConfig !== undefined && object.securityConfig !== null)
      ? RemoteApiSecurityConfig.fromPartial(object.securityConfig)
      : undefined;
    message.host = object.host ?? "";
    message.tlsRequired = object.tlsRequired ?? false;
    message.maxRequestSizeBytes = object.maxRequestSizeBytes ?? 0;
    message.maxResponseSizeBytes = object.maxResponseSizeBytes ?? 0;
    message.maxResponseTimeMillis = object.maxResponseTimeMillis ?? 0;
    message.approvalState = object.approvalState ?? SpecApprovalState.APPROVAL_STATE_UNSET;
    message.visibility = object.visibility ?? SpecVisibility.VISIBILITY_UNSET;
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? RemoteApiSpecMetadata.fromPartial(object.metadata)
      : undefined;
    message.targetPlatforms = object.targetPlatforms?.map((e) => e) || [];
    message.customVisibilityUsers = object.customVisibilityUsers?.map((e) => e) || [];
    message.localOnly = object.localOnly ?? false;
    message.lastAccessTimeSec = object.lastAccessTimeSec ?? "0";
    message.restrictedJsApiPermissions = object.restrictedJsApiPermissions?.map((e) => e) || [];
    message.minLensStudioVersion = object.minLensStudioVersion ?? "";
    message.sponsoredLensRestricted = object.sponsoredLensRestricted ?? false;
    message.editPermissionUsers = object.editPermissionUsers?.map((e) => e) || [];
    message.grpcEndpoints = object.grpcEndpoints?.map((e) => RemoteApiGrpcEndpoint.fromPartial(e)) || [];
    message.snapkitAppId = object.snapkitAppId ?? "";
    message.useBuiltinLocalProcessor = object.useBuiltinLocalProcessor ?? false;
    message.orgId = object.orgId ?? "";
    message.allowRedirects = object.allowRedirects ?? false;
    return message;
  },
};

function createBaseRemoteApiSpecSetMetadata(): RemoteApiSpecSetMetadata {
  return {
    name: "",
    iconUrl: "",
    providerName: "",
    description: "",
    author: "",
    creationTimeSec: "0",
    lastEditTimeSec: "0",
    lastEditor: "",
    documentationUrl: "",
    createdFrom: CreatedFrom.CREATED_FROM_UNSET,
  };
}

export const RemoteApiSpecSetMetadata: MessageFns<RemoteApiSpecSetMetadata> = {
  encode(message: RemoteApiSpecSetMetadata, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.iconUrl !== "") {
      writer.uint32(18).string(message.iconUrl);
    }
    if (message.providerName !== "") {
      writer.uint32(26).string(message.providerName);
    }
    if (message.description !== "") {
      writer.uint32(34).string(message.description);
    }
    if (message.author !== "") {
      writer.uint32(42).string(message.author);
    }
    if (message.creationTimeSec !== "0") {
      writer.uint32(48).int64(message.creationTimeSec);
    }
    if (message.lastEditTimeSec !== "0") {
      writer.uint32(56).int64(message.lastEditTimeSec);
    }
    if (message.lastEditor !== "") {
      writer.uint32(66).string(message.lastEditor);
    }
    if (message.documentationUrl !== "") {
      writer.uint32(74).string(message.documentationUrl);
    }
    if (message.createdFrom !== CreatedFrom.CREATED_FROM_UNSET) {
      writer.uint32(80).int32(createdFromToNumber(message.createdFrom));
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiSpecSetMetadata {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiSpecSetMetadata();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.iconUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.providerName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.author = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.creationTimeSec = reader.int64().toString();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.lastEditTimeSec = reader.int64().toString();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.lastEditor = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.documentationUrl = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.createdFrom = createdFromFromJSON(reader.int32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiSpecSetMetadata>, I>>(base?: I): RemoteApiSpecSetMetadata {
    return RemoteApiSpecSetMetadata.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiSpecSetMetadata>, I>>(object: I): RemoteApiSpecSetMetadata {
    const message = createBaseRemoteApiSpecSetMetadata();
    message.name = object.name ?? "";
    message.iconUrl = object.iconUrl ?? "";
    message.providerName = object.providerName ?? "";
    message.description = object.description ?? "";
    message.author = object.author ?? "";
    message.creationTimeSec = object.creationTimeSec ?? "0";
    message.lastEditTimeSec = object.lastEditTimeSec ?? "0";
    message.lastEditor = object.lastEditor ?? "";
    message.documentationUrl = object.documentationUrl ?? "";
    message.createdFrom = object.createdFrom ?? CreatedFrom.CREATED_FROM_UNSET;
    return message;
  },
};

function createBaseRemoteApiSpecSet(): RemoteApiSpecSet {
  return { id: "", specs: [], metadata: undefined, lastAccessTimeSec: "0" };
}

export const RemoteApiSpecSet: MessageFns<RemoteApiSpecSet> = {
  encode(message: RemoteApiSpecSet, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.specs) {
      RemoteApiSpec.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.metadata !== undefined) {
      RemoteApiSpecSetMetadata.encode(message.metadata, writer.uint32(26).fork()).join();
    }
    if (message.lastAccessTimeSec !== "0") {
      writer.uint32(32).int64(message.lastAccessTimeSec);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiSpecSet {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoteApiSpecSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.specs.push(RemoteApiSpec.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.metadata = RemoteApiSpecSetMetadata.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.lastAccessTimeSec = reader.int64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<RemoteApiSpecSet>, I>>(base?: I): RemoteApiSpecSet {
    return RemoteApiSpecSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RemoteApiSpecSet>, I>>(object: I): RemoteApiSpecSet {
    const message = createBaseRemoteApiSpecSet();
    message.id = object.id ?? "";
    message.specs = object.specs?.map((e) => RemoteApiSpec.fromPartial(e)) || [];
    message.metadata = (object.metadata !== undefined && object.metadata !== null)
      ? RemoteApiSpecSetMetadata.fromPartial(object.metadata)
      : undefined;
    message.lastAccessTimeSec = object.lastAccessTimeSec ?? "0";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
